module.exports = __webpack_public_path__ + "media/assets_v3/images/csgo-ranks/9-dd363906fb757b92d228d6a06ee2429f.png";